export default __webpack_public_path__ + "static/media/DISTRIBUCION_ITEM_ICON_1.5b322c12.svg";